import React, { useCallback, useEffect } from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { SortingPanel } from '../../..';

import styles from './index.module.css';

export const FilterDropDown = ({
  visible,
  onVisibleChange,
  children,
  content,
  applyStyles,
  overlayClassName,
  showDateRange,
  shouldRenderSorting = true,
  values,
  name,
  setFieldValue,
}) => {
  const onHorizontalScroll = useCallback(
    (e) => {
      if (e.currentTarget.scrollLeft > 10) {
        onVisibleChange(false);
      }
    },
    [onVisibleChange],
  );
  useEffect(() => {
    const table = document.querySelector('.ant-table-body');

    if (table) {
      table?.addEventListener('scroll', onHorizontalScroll);
    }
    return () => table?.removeEventListener('scroll', onHorizontalScroll);
  }, [onHorizontalScroll]);

  return (
    <div className={styles.filterRow}>
      <Popover
        open={visible}
        placement='bottomLeft'
        trigger='click'
        destroyOnHidden={false}
        onOpenChange={onVisibleChange}
        content={content}
        classNames={{
          root: classNames({
            [styles.customPopOver]: true,
            [styles.popOver]: applyStyles,
            [styles.overlay]: applyStyles,
            [styles.dateRangeVisible]: showDateRange,
          }, overlayClassName),
        }}
        getPopupContainer={() => document.querySelector('.ant-table')}>
        <div className={styles.filter}>{children}</div>
      </Popover>
      {shouldRenderSorting && <SortingPanel values={values} name={name} setFieldValue={setFieldValue} />}
    </div>
  );
};

FilterDropDown.propTypes = {
  visible: PropTypes.bool,
  onVisibleChange: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  content: PropTypes.node,
  applyStyles: PropTypes.bool,
  overlayClassName: PropTypes.string,
  showDateRange: PropTypes.bool,
};
